import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOneMeetingRequestPayload } from '@app-store/slices/meetingRequests/oneMeetingRequest'

interface TaskAction extends Action {
    payload: IOneMeetingRequestPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.one

function* oneMeetingRequestSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/meeting-requests/one/${payload.requestId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError()
    }
}

function* oneMeetingRequestSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneMeetingRequestSagaTask)
}

export default oneMeetingRequestSaga
